// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5l-0";
export var eligibilityCardNotEligible = "_5l-1";